import { useParams } from "react-router-dom";
import { useModal } from "../../../../contexts/ModalContext";
import { useDialog } from "../../../../contexts/DialogContext";
import TableComplete from "../../../../components/Tables/TableComplete";
import { Circle } from "../../../../components/Animation";
import { H2, H3 } from "../../../../components/Text";
import { FillForm, SendProcedure } from "../../../../containers/steps";
import { Request } from "../../../../hooks/Request";
import { validateArray } from "../../../../utils/validate";

const listFields = [
  "esSubasta",
  "requiereSeguro?",
  "datosGeneralesDeTransporte",
];

const FolderStep = () => {
  const { rolId, procedureId } = useParams();
  const { openModal, onClose } = useModal();
  const { openDialog } = useDialog();

  const { data, loading, call } = Request({
    urlApi: `/procedure/${procedureId}/general`,
  });

  const { data: dataValues, loading: dataValuesLoading } = Request({
    urlApi: `/Procedure/${procedureId}/dataValues?${listFields
      .map((field) => `fieldnames=${field}`)
      .join("&")}`,
  });

  const isStepBlocked = (step) => {
    return (
      (step.step === 2 && dataValues?.esSubasta === "") ||
      (step.step === 10 && dataValues?.["requiereSeguro?"] === "") ||
      (step.step > 12 &&
        step.step < 15 &&
        JSON.parse(dataValues?.datosGeneralesDeTransporte || "{}")
          ?.a13ParteModalidadDeTransporte) === "AEREO"
    );
  };

  function handleStepForm(step) {
    if (!isStepBlocked(step)) {
      openModal(
        <FillForm
          procedure={{
            id: data.procedureId,
            processStepId: step.processStepId,
            category: data.category,
          }}
          reload={call}
          onClose={onClose}
          openModal={openModal}
          rolId={rolId}
          rols={step.rols}
          // step={rol === "accountant" ? "4" : "3"}
          step={step.step}
          typeId={data.processStepId}
          handleSendProcedure={handleSendProcedure}
        />,
      );
    }

    // : openDialog(
    //     <div className="mb-5 text-center">
    //       <h2 className="text-xl">
    //         Debes llenar el paso en progreso primero
    //       </h2>
    //       <h3 className="">
    //         Paso en progreso:{" "}
    //         <span className="font-medium">{data.processStepName}</span>{" "}
    //       </h3>
    //     </div>
    //   );
  }

  function handleSendProcedure(procedure, reloadTable) {
    openModal(
      <SendProcedure
        openModal={openModal}
        procedure={procedure}
        reload={reloadTable}
        onClose={onClose}
      />,
    );
  }

  if (!loading) {
    return <Circle />;
  }

  return (
    <div className="uppercase">
      {/* <div className="flex">
        <div className="w-1/2">
          <h3>
            <span className="font-medium">Tramite:</span> {}
          </h3>
          <h3>
            <span className="font-medium">Descripción de Producto:</span> {}
          </h3>
        </div>
        <div className="w-1/2">
          <h3>
            <span className="font-medium">Paso actual:</span>{" "}
            {data.processStepName}
          </h3>
          <h3>
            <span className="font-medium">DIM:</span>
          </h3>
        </div>
      </div> */}

      <TableComplete
        // data={data}
        // call={call}
        // height={currentSize.height ? currentSize.height : null}
        // buttons={buttons}
        data={data.steps}
        onClick={handleStepForm}
        urlApi={`/procedure/${procedureId}/general`}
        header={[
          { name: "step", label: "Nro" },
          { name: "processStepName", label: "Paso" },
          {
            name: "startDate",
            label: "Estado",
            type: "custom",
            builder: (value, _, step) => {
              const blocked = isStepBlocked(step);
              return (
                <div
                  className={`w-fit text-center rounded-full py-1 px-4 ${
                    blocked
                      ? "bg-yellow-400 text-white"
                      : step.finishDate
                        ? "bg-green-500 text-white"
                        : value
                          ? "bg-blue-500 text-white"
                          : "bg-[#74747431] text-gray-500"
                  }`}
                >
                  {blocked
                    ? "Sin solicitud en una etapa anterior"
                    : step.finishDate
                      ? "Completado"
                      : value
                        ? "En progreso"
                        : "No iniciado"}
                </div>
              );
            },
          },
          { name: "startDate", label: "Inicio", type: "date" },
          { name: "finishDate", label: "Fin", type: "date" },
          {
            name: "rols",
            label: "Roles",
            type: "custom",
            builder: (rols) => {
              return (
                <div className="flex flex-col gap-1">
                  {rols.map((rol) => (
                    <div
                      className="w-fit border-2 border-gray-500 rounded-md px-1"
                      key={rol.id}
                    >
                      {rol.label}
                    </div>
                  ))}
                </div>
              );
            },
          },
        ]}
      />
    </div>
  );
};

export default FolderStep;
